const LAST_RELOAD_KEY = 'raldo.stale-chunk-reload'
const RELOAD_COOLDOWN_MS = 10_000

/** Injectable seams so the handler can be tested without a real window. */
export interface StaleChunkReloadOptions {
  target?: EventTarget
  reload?: () => void
  storage?: Storage | undefined
  now?: () => number
}

function readLastReload(storage: Storage | undefined): number {
  if (storage === undefined) return 0
  try {
    return Number.parseInt(storage.getItem(LAST_RELOAD_KEY) ?? '', 10) || 0
  } catch {
    return 0
  }
}

function writeLastReload(storage: Storage | undefined, at: number): void {
  if (storage === undefined) return
  try {
    storage.setItem(LAST_RELOAD_KEY, String(at))
  } catch {
    /* Private-mode storage refuses writes; a reload loop is guarded by the cooldown anyway. */
  }
}

/** Reloads a tab that outlived a deploy when `vite:preloadError` fires; a cooldown stops a loop when the chunk is missing for another reason. */
export function installStaleChunkReload(options: StaleChunkReloadOptions = {}): void {
  const {
    target = window,
    reload = () => window.location.reload(),
    storage = typeof sessionStorage === 'undefined' ? undefined : sessionStorage,
    now = () => Date.now(),
  } = options

  target.addEventListener('vite:preloadError', (event) => {
    const at = now()
    if (at - readLastReload(storage) < RELOAD_COOLDOWN_MS) return

    event.preventDefault()
    writeLastReload(storage, at)
    reload()
  })
}
